import minimal from '@/styles/theme/presets/minimal'
import profiteia from '@/styles/theme/presets/profiteia'

export const themePresets = {
  profiteia,
  minimal,
}

export const availableThemes = Object.values(themePresets)

export default themePresets
